import React, { Fragment } from 'react'

export default function SkeletonLoans() {
  return (
    <Fragment>
        <section id="loansServices">
    <div className="loanAmount">
        <p className="cic-heading-3 spaceLoans spaceHeight"><span className='rect-gray loading-info'>Available Loans Near Me, CA</span></p>
        <div className="availableL">
            <span className='rect-gray loading-info'>
                <img 
                    className='cic-gray-filter'
                    width="24px" 
                    height="24px" 
                    alt="Payroll Advances Icon" 
                    src="https://cacheckcashdev.wpengine.com/wp-content/plugins/cic-atomic-bb-powerpack/assets/icons/cic-prod-payday-ca-cashing.svg" 
                />
                <a target="_blank" rel="noopener noreferrer"><strong>Payroll Advances</strong></a> up to $250
            </span>
            <span className='rect-gray loading-info'>Available in stores and online</span>
        </div>
    </div>
    <div className="cicServices">
        <p className="cic-heading-3 spaceLoans spaceHeight"><span className='rect-gray loading-info'>Available Services Near Me, CA</span></p>
        <div className="availableS ">
            <span className='rect-gray loading-info'>
                <img className='cic-gray-filter' width="24px" height="24px" alt="Check Cashing Icon" src="https://localstoresprd.wpenginepowered.com/wp-content/plugins/cic-atomic-bb-powerpack/assets/icons/cic-serv-check-cashing.svg" /> <strong>Check Cashing</strong>
            </span>
            <span className='rect-gray loading-info'>
                <img className='cic-gray-filter' width="24px" height="24px" alt="Reloadable Debit Card Icon" src="https://localstoresprd.wpenginepowered.com/wp-content/plugins/cic-atomic-bb-powerpack/assets/icons/cic-serv-us-money-card-default.svg" />
                <strong>Reloadable Debit Card</strong>
            </span>
            <span className='rect-gray loading-info'>
                <img className='cic-gray-filter' width="24px" height="24px" alt="Bill Pay Icon" src="https://localstoresprd.wpenginepowered.com/wp-content/plugins/cic-atomic-bb-powerpack/assets/icons/cic-serv-bill-pay.svg" /> <strong>Bill Pay</strong>
            </span>
            
            <span className='rect-gray loading-info'>
                <img className='cic-gray-filter' width="24px" height="24px" alt="Tax Preparation Icon" src="https://localstoresprd.wpenginepowered.com/wp-content/plugins/cic-atomic-bb-powerpack/assets/icons/cic-icon-sm-tax-prep.svg" /> <strong>Tax Preparation</strong>
            </span>
            <span className='rect-gray loading-info'>
                <img className='cic-gray-filter' width="24px" height="24px" alt="Western Union Money Transfer Icon" src="https://localstoresprd.wpenginepowered.com/wp-content/plugins/cic-atomic-bb-powerpack/assets/icons/cic-serv-western-union.svg" />
                <strong>Western Union Money Transfer</strong>
            </span>
            <span className='rect-gray loading-info'>
                <img className='cic-gray-filter' width="24px" height="24px" alt="Western Union Money Orders Icon" src="https://localstoresprd.wpenginepowered.com/wp-content/plugins/cic-atomic-bb-powerpack/assets/icons/cic-serv-money-orders.svg" />
                <strong>Western Union Money Orders</strong>
            </span>
            <span className='rect-gray loading-info'>
                <img className='cic-gray-filter' width="24px" height="24px" alt="Green Dot Visa® Debit Cards Icon" src="https://localstoresprd.wpenginepowered.com/wp-content/plugins/cic-atomic-bb-powerpack/assets/icons/cic-ui-green-dot.svg" />
                <strong>Green Dot Visa® Debit Cards</strong>
            </span>
        </div>
    </div>
</section>

    </Fragment>
  )
}
